import React, { useState, useEffect } from 'react';
import { Form, Button } from 'antd';
import UIObject from './UIObject';
import { InputField } from './InputField';

interface InputFormByObjectProps {
    uiObject: UIObject,
    submitButton?: string,
    onChange?: (data: any) => Promise<void>,
    onCancel?: (data: any) => Promise<void>,
    onSubmit?: (data: any) => Promise<boolean>,
    onFinish?: () => Promise<boolean>,
    isLoading?: boolean
}


export default function InputFormByObject(props: InputFormByObjectProps) {
    const [form] = Form.useForm();
    const { onChange, onFinish, onSubmit, uiObject, onCancel } = props
    const submit_label = props.submitButton ? props.submitButton : 'Submit';
    const [data, setData] = useState({});
    const [disable, setDisable] = useState(false);
    const [isLoading, setIsLoading] = useState(props.isLoading);
    // const []

    useEffect(() => {
        if (uiObject) {
            console.log('Set initvalues: ', uiObject);
            clearForm();
            form.setFieldsValue(uiObject.getOriginData());
            // form.setFieldsValue({name:"aaaaa"});
            uiObject.onDataChanged = onChange
            setData(uiObject.data())
        } else form.setFieldsValue({});
    }, [form, uiObject]);

    const onChangeFileHandler = (event: any) => {
        console.log(event.target.files[0]);
        if (event.target.files[0].status === 'uploading') {
            setIsLoading(true);
            return;
        }
        if (event.target.files[0].status === 'done') {
            // Get this url from response in real world.
            // ImageHelper.getBase64(event.target.files[0], imageUrl => {
            //     onChangeData(key, imageUrl);
            //     setIsLoading(false);
            // });
            // const reader = new FileReader();
        }
        console.log('Upload DONE');
    };

    uiObject.onSubmit = (values: any) => {
        console.log('Received values of form: ', values);
        setDisable(true);
        submit(values);
    };

    const onFinishFailed = (error: any) => {
        console.log('Submit Failed', error);
    };

    const submit = async (values: any) => {
        setIsLoading(true);
        let success = false;
        if (onSubmit) success = await onSubmit(values);
        if (success) {
            await onFinishListener();
        } else onFinishFailed(success)
        setIsLoading(false);
        setDisable(false);
    };

    const onFinishListener = async () => {
        onFinish && (await onFinish());
        clearForm();
    };

    const clearForm = () => {
        const originData = uiObject.getOriginData();
        onChange && onChange(originData);
        setData(originData);
        form.resetFields();
    };

    // const { getFieldDecorator } = form;
    const formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
    };

    return (
        <Form
            onFinish={uiObject.onSubmit}
            onFinishFailed={onFinishFailed}
            form={form}
            initialValues={uiObject.getOriginData()}
            {...formItemLayout}
        >
            {uiObject?<ObjectInput inputObject={uiObject}/>:<div>Cannot generate object UI</div>}
            {/* {uiObject?uiObject.generateFormUI():<div>Cannot generate object UI</div>} */}
            <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100%', height: '30px' }}
                disabled={disable}
                loading={isLoading}
            >
                {submit_label}
            </Button>
        </Form>
    );
}

export interface IInputObjectProps {
    inputObject: UIObject
}

export function ObjectInput(props: any) {
    // const {inputObject}=props
    // const [uiObject, setUIObject] = useState(inputObject)
    const uiObject = props.inputObject
    // useEffect(()=>{
    //     console.log("OBJECT INPUT UI: ", uiObject)
    //     if(uiObject)
    //         uiObject.mapData()
    // },[uiObject])
    return (<>
        {/* {this.groupView(this.groups, this.view === 'tab' ? 'tab' : 'flat')} */}
        {
            uiObject.sortedFields.map((item:InputField) => {
                // console.log("FIELD: ", item)
                if (!item.group)
                    return item.generateUI()
                else return null
            })
        }
    </>)
} 

export const lockField = (value: any) => <span style={{ color: 'darkgray' }}>{value}</span>
